"use strict";
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutBottomRowTwoTiles = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var iconTypes_1 = require("../../iconTypes");
var svgIconContainer_1 = require("../../svgIconContainer");
exports.LayoutBottomRowTwoTiles = React.forwardRef(function (props, ref) {
    var isLarge = props.size >= iconTypes_1.IconSize.LARGE;
    var pixelGridSize = isLarge ? iconTypes_1.IconSize.LARGE : iconTypes_1.IconSize.STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = { transformOrigin: "center" };
    return (React.createElement(svgIconContainer_1.SVGIconContainer, tslib_1.__assign({ iconName: "layout-bottom-row-two-tiles", ref: ref }, props),
        React.createElement("path", { d: isLarge ? "M0 160C0 171.046 8.9543 180 20 180H160C171.0456 180 180 171.046 180 160V20C180 8.954 171.0456 0 160 0H20C8.9543 0 0 8.954 0 20V160zM220 160C220 171.046 228.954 180 240 180H380C391.046 180 400 171.046 400 160V20C400 8.954 391.046 0 380 0H240C228.954 0 220 8.954 220 20V160zM0 380C0 391.0457 8.9543 400 20 400H380C391.046 400 400 391.0457 400 380V240C400 228.9544 391.046 220 380 220H20C8.95432 220 0 228.9544 0 240V380z" : "M120 140C131.0456 140 140 131.0456 140 120V20C140 8.954 131.0456 0 120 0H20C8.9543 0 0 8.954 0 20V120C0 131.0456 8.9543 140 20 140H120zM300 140C311.046 140 320 131.0456 320 120V20C320 8.954 311.046 0 300 0H200C188.9544 0 180 8.954 180 20V120C180 131.0456 188.9544 140 200 140H300zM300 320C311.046 320 320 311.0457 320 300V200C320 188.9544 311.046 180 300 180H20C8.9543 180 0 188.9544 0 200V300C0 311.0457 8.9543 320 20 320H300z", fillRule: "evenodd", transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"), style: style })));
});
exports.LayoutBottomRowTwoTiles.defaultProps = {
    size: iconTypes_1.IconSize.STANDARD,
};
exports.LayoutBottomRowTwoTiles.displayName = "Blueprint5.Icon.LayoutBottomRowTwoTiles";
exports.default = exports.LayoutBottomRowTwoTiles;
//# sourceMappingURL=layout-bottom-row-two-tiles.js.map